import { Component, OnInit } from '@angular/core';
import {StorageService} from '../../shared/services/storage.service';
import {PaiuLeadService} from '../../shared/services/paiu-lead.service';

@Component({
  selector: 'app-paiu-lead',
  templateUrl: './paiu-lead.component.html',
  styleUrls: ['./paiu-lead.component.scss']
})
export class PaiuLeadComponent implements OnInit {
    showSearch = false;
    user: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 30,
        pages: null
    };
    submitting: any = false;
    leads = [];
  constructor(
   private paiuLeadService: PaiuLeadService,
  ) {  this.user = StorageService.getItem('self'); }

    ngOnInit(): void {
        this.refresh();
    }
    refresh() {
        this.get();
    }
    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.leads = [];
        this.paiuLeadService.get(params).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.leads = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.leads = [];
            }
            this.submitting = false;
            }, error => {
            this.submitting = false;
            }
        );
    }
    onPageChange(page) {
        this.pagination.page = page;
        const params = {
           // 'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }
}
